// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowStatusNextActionsInner
 */
export interface WorkflowStatusNextActionsInner {
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusNextActionsInner
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusNextActionsInner
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusNextActionsInner
     */
    required_role: string;
}

/**
 * Check if a given object implements the WorkflowStatusNextActionsInner interface.
 */
export function instanceOfWorkflowStatusNextActionsInner(value: object): value is WorkflowStatusNextActionsInner {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('required_role' in value) || value['required_role'] === undefined) return false;
    return true;
}

export function WorkflowStatusNextActionsInnerFromJSON(json: any): WorkflowStatusNextActionsInner {
    return WorkflowStatusNextActionsInnerFromJSONTyped(json, false);
}

export function WorkflowStatusNextActionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowStatusNextActionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'description': json['description'],
        'required_role': json['required_role'],
    };
}

export function WorkflowStatusNextActionsInnerToJSON(json: any): WorkflowStatusNextActionsInner {
    return WorkflowStatusNextActionsInnerToJSONTyped(json, false);
}

export function WorkflowStatusNextActionsInnerToJSONTyped(value?: WorkflowStatusNextActionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'description': value['description'],
        'required_role': value['required_role'],
    };
}
